import { FbLink } from 'components/FbUI/FbLink'
import { OverflownText } from 'components/OverflownText'

interface TruncatedLinkCellProps {
  text: string
  to: string
  tooltipText?: string
  target?: string
}

export const TruncatedLinkCell = ({
  text,
  to,
  tooltipText,
  target = '_blank',
}: TruncatedLinkCellProps) => {
  return (
    <div className="max-w-full" style={{ minWidth: 0, flex: 1 }}>
      <OverflownText tooltipText={tooltipText || text}>
        <div
          style={{
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          <FbLink to={to} target={target}>
            {text}
          </FbLink>
        </div>
      </OverflownText>
    </div>
  )
}
